import type { ITileManagerModel, IConnectionModel } from '@/interfaces/models';
import { ConnectionModel } from '@/models/connections/ConnectionModel';
import type { ConnectionGraphDto } from '@/models/connections/ConnectionGraph';
import { ConnectionCalculator } from '@/models/connections/ConnectionCalculator';
import type { TileType } from '@/models/TileTypes';
import type { TileDefinition } from '@/models/tiles/TileDefinition';

export class ConnectionModelFactory {
  private readonly connectionCalculator: ConnectionCalculator;

  constructor(getTileDefinition: (type: TileType) => TileDefinition<unknown>) {
    this.connectionCalculator = new ConnectionCalculator({ getTileDefinition });
  }

  create(tileManagerModel: ITileManagerModel): IConnectionModel {
    return new ConnectionModel({
      tileManagerModel,
      connectionCalculator: this.connectionCalculator,
    });
  }

  fromDto(
    tileManagerModel: ITileManagerModel,
    connectionGraphDto?: ConnectionGraphDto,
  ): IConnectionModel {
    return new ConnectionModel({
      tileManagerModel,
      connectionCalculator: this.connectionCalculator,
      connectionDto: connectionGraphDto,
    });
  }
}
